import * as Headless from "@headlessui/react";
import { ElementType, ReactElement } from "react";

import { Button } from "./Button.tsx";

export const DropdownButton = <T extends ElementType = typeof Button>({
  as = Button,
  ...props
}: { className?: string } & Omit<
  Headless.MenuButtonProps<T>,
  "className"
>): ReactElement => <Headless.MenuButton as={as} {...props} />;
